<template>
  <div class="asc-role-dialog-grid">
    <asc-ag-grid-filter
      :key="`asc-role-dialog-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="gridColumns"
      :row-data="agGridRowData"
      grid-size="lg"
      :group-default-expanded="-1"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscAgGridAutocompleteFloatFilter,
} from '@/components/agGrid'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscRoleDialogGrid',

  components: {
    AscAgGridFilter,
    AscAgGridAutocompleteFloatFilter,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    allResourceModules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          floatingFilter: false,
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        suppressCellFocus: true,
        noRowsOverlayComponent: this.noOverlayComponent,
        onGridReady: this.handleGridReady,
        onGridSizeChanged: this.handleGridSizeChanged,
        groupDisplayType: 'groupRows',
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      this.resetLocalStorage(this.localStorageName)
      return this.mappedValues
    },
  },

  watch: {},

  methods: {
    handleCellClicked(event) {
      this.onOpen(event.data)
    },
    handleGridCheckboxToggle(val) {
      //this.$emit('onGridCheckboxToggle', val)
      console.log(val)
    },
    handleGridReady(params) {
      if (params && params.type === 'gridReady' && params.api)
        this.$emit('onRoleGridReady', params.api)
    },
  },
}
</script>

<style lang="scss" scoped></style>
